import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { OrdersService } from 'src/app/services/orders.service';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';
import { SessionService } from 'src/app/services/shared/session.service';

/**
 * Sub-modale "Conferma cancellazione ordine".
 * - Conferma identità con password della sessione corrente.
 * - On success: emette `canceledSucces` per refresh lista parent.
 *
 * Cleanup v2.11.0 J.1:
 * - DROP HttpClient + getIPAddress(): chiamata a ipify.org mai usata
 *   (ipAddress catturato ma non mandato al server in cancelOrder).
 * - DROP loginForm.email + .keepLogged: campi mai usati (email arriva
 *   da SessionService.getCurrentUser().ac_email).
 * - DROP checkPass() metodo dead (mai chiamato dal template).
 * - DROP kendo-textbox + TextBoxComponent ViewChild hack: nativo
 *   `<input type="password|text">` con boolean toggle.
 * - Switch a `inject()` + `takeUntilDestroyed`.
 */
@Component({
  selector: 'app-confirm-cancel',
  templateUrl: './confirm-cancel.component.html',
  styleUrls: ['./confirm-cancel.component.scss'],
  standalone: false,
})


export class ConfirmCancelComponent implements OnInit {

  @Input() openConfirmCancel = false;
  @Input() orderToGet: any;
  @Output() canceledSucces = new EventEmitter<void>();

  private destroyRef = inject(DestroyRef);
  private orderService = inject(OrdersService);
  private session = inject(SessionService);
  public openModal = inject(OpenModalService); // public per template
  private cdr = inject(ChangeDetectorRef);

  // Form: solo password (email arriva da SessionService a submit-time).
  public form: FormGroup = new FormGroup({
    password: new FormControl('', Validators.required),
  });

  public showPassword = false;
  public submitting = false;

  ngOnInit(): void {
    // Reset stato all'apertura del modale.
    this.form.reset();
    this.showPassword = false;
    this.submitting = false;
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  confirmDelete(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid || this.submitting) return;

    const currentUser = this.session.getCurrentUser() ?? {};
    const password = this.form.value.password as string;

    this.submitting = true;
    this.orderService
      .cancelOrder(this.orderToGet?.order_id, currentUser.ac_email, password)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (res: any) => {
          this.submitting = false;
          if (res?.success) {
            Swal.fire({
              icon: 'success',
              title: 'Cancellato!',
              text: 'Ordine annullato con successo!',
              timer: 1500,
              timerProgressBar: true,
            });
            this.canceledSucces.emit();
            this.openModal.offConfirmCancel();
          } 
          else {
            Swal.fire({
              icon: 'warning',
              title: 'Attenzione!',
              text: 'Password non corretta. Riprova.',
              timer: 1500,
              timerProgressBar: true,
            });
          }
          this.cdr.detectChanges();
        },
        error: () => {
          this.submitting = false;
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: 'Impossibile annullare. Riprova più tardi.',
            timer: 1500,
            timerProgressBar: true,
          });
          this.cdr.detectChanges();
        },
      });
  }

  closeModal(): void {
    this.openModal.offConfirmCancel();
  }

}
